import * as Yup from 'yup'

import type { DeviceType } from '~/types/device-type'

import { DEVICE_TYPE, FORM_ERRORS } from '~/const'

export const YupOption = Yup.object({ label: Yup.string(), value: Yup.string() })

export const RequiredYupOption = Yup.object({
  label: Yup.string().required(FORM_ERRORS.REQUIRED),
  value: Yup.string().required(FORM_ERRORS.REQUIRED),
})

/** @doc For IAppOption in types/option.ts */
export const YupAppOption = Yup.object().shape({
  appKey: Yup.string().required(),
  deviceType: Yup.mixed<DeviceType>().oneOf(Object.values(DEVICE_TYPE)).required(),
  label: Yup.string().required(),
  url: Yup.string(),
  value: Yup.string().required(),
})
